import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import qs from 'qs';

import SimpleModal from '../../components/SimpleModal';
import TopHeader from '../../layouts/TopHeader';
import DocumentExample from './actions/DocumentExample';
import DocumentActions from './actions/DocumentActions';
import AttachmentList from './actions/AttachmentList';
import ReferenceDocumentList from './actions/ReferenceDocumentList';

import SelectReviewer from '../../components/WorkflowActions/SelectReviewer';
import AddComment from '../../components/WorkflowActions/AddComment';
import Confirm from '../../components/WorkflowActions/Confirm';
import IssueNumber from '../../components/WorkflowActions/IssueNumber';
import ReceiveNumber from '../../components/WorkflowActions/ReceiveNumber';
import Note from '../../components/WorkflowActions/Note';
import EditNote from '../../components/WorkflowActions/EditNote';
import Order from '../../components/WorkflowActions/Order';
import Forward from '../../components/WorkflowActions/Forward';
import ForwardSecretary from '../../components/WorkflowActions/ForwardSecretary';
import CommentList from '../../components/WorkflowActions/CommentList';
import AfterSaveLoading from '../../components/AfterSaveLoading';

import DocumentStore from '../../stores/DocumentStore';
import WorkflowProcessStore from '../../stores/WorkflowProcessStore';
import LoginSession from '../../stores/LoginSession';

class ShowDocument extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      document: {},
      workflow_process: {},
      workflow_process_histories: [],
      comment_wph_histories: [],
      workflow_states: [],
      workflow_state_actions: [],
      attachments: [],
      reference_documents: [],
      all_users: [],
      internal_users: [],
      informee_positions_users: [],
      department_groups: [],
      secretary_groups: [],
      actings: [],
      acting_positions_user_ids: [],
      show_attachment: false,
      show_reference_document: false,
      action_name: "",
      modal_open: false,
      modal_title: "",
      modal_form: "",
      clicked: false,
      confirmed: false,
      comments: [],
      comment_files: [],
      isSecretary: false,
      pdf_file: ''
    }

    this.attachmentToggle = this.attachmentToggle.bind(this);
    this.referenceDocumentToggle = this.referenceDocumentToggle.bind(this);
    this.handleActionClick = this.handleActionClick.bind(this);
    this.redirectToEditDocumentPage = this.redirectToEditDocumentPage.bind(this);
    this.redirectBack = this.redirectBack.bind(this);
    this.openReviewerModal = this.openReviewerModal.bind(this);
    this.openCommentListModal = this.openCommentListModal.bind(this);
    this.handleSaveNoteMessage = this.handleSaveNoteMessage.bind(this);
    this.handleUpdateNoteMessage = this.handleUpdateNoteMessage.bind(this);
    this.handleSubmitAction = this.handleSubmitAction.bind(this);
    this.handleOrder = this.handleOrder.bind(this);
    this.handleForward = this.handleForward.bind(this);
    this.handleForwardSecretary = this.handleForwardSecretary.bind(this);
    this.handleSubmitIssueNumber = this.handleSubmitIssueNumber.bind(this);
    this.handleSubmitReceiveNumber = this.handleSubmitReceiveNumber.bind(this);
    this.handleReloadWithoutPreview = this.handleReloadWithoutPreview.bind(this);
    this.handleArchiveDocument = this.handleArchiveDocument.bind(this);
    this.handleReloadDocument = this.handleReloadDocument.bind(this);
    this.handleCloneDocument = this.handleCloneDocument.bind(this);
    this.reloadWorkflowProcess = this.reloadWorkflowProcess.bind(this);
    this.onCloseModal = this.onCloseModal.bind(this);
    this.preventMultiClicks = this.preventMultiClicks.bind(this);
    this.preventMultiConfirms = this.preventMultiConfirms.bind(this);
    this.disabledClick = this.disabledClick.bind(this);
    this.fetchInternalUsers = this.fetchInternalUsers.bind(this);
    this.fetchCommentWorkflowProcessHistory = this.fetchCommentWorkflowProcessHistory.bind(this);
  }

  componentDidMount(){
    DocumentStore.request({id: this.props.document_id}, 20000).then((resp)=>{
      let document = _.get(resp.data, 'data', {});
      let included = _.get(resp.data, 'included', {});
      let attachments = included.attachments || [];
      let reference_documents = included.reference_documents || [];
      let actings = included.actings || [];
      let acting_positions_user_ids = _.map(actings, 'attributes.positions_user.id') || [];

      this.setState({
        document: document,
        attachments: attachments,
        reference_documents: reference_documents,
        actings: actings,
        acting_positions_user_ids: acting_positions_user_ids,
      })
    }).then(()=>{
      this.reloadWorkflowProcess(this.props.workflow_process_id);
    }, function(error){
      window.location.reload();
    });
  }

  preventMultiClicks(){
    this.setState({clicked: true});

    setTimeout(() => {
      this.setState({clicked: false});
    }, 5000);
  }

  preventMultiConfirms(){
    this.setState({confirmed: true});
  }

  disabledClick(){
    this.setState({clicked: true});
  }

  reloadWorkflowProcess(workflow_process_id){
    var self = this;
   
    WorkflowProcessStore.request({id: workflow_process_id}).then((resp)=>{
      let workflow_process = _.get(resp.data, 'data', {});
      let included = _.get(resp.data, 'included', {});
      let workflow_states = included.workflow_states || [];
      let workflow_state_actions = included.workflow_state_actions || [];
      const comments = _.get(included, 'comments', []);
      const comment_files = _.get(included, 'comment_files', []);

      const isSecretary = _.find(workflow_process.attributes.positions_users, { id: LoginSession.current.user.informer_positions_user_id });

      this.setState({ 
        workflow_process: workflow_process,
        workflow_states: workflow_states,
        workflow_state_actions: workflow_state_actions,
        comments: comments,
        comment_files: comment_files,
        isSecretary: isSecretary
      })
    }, function(error){
      let error_message = _.get(error.response.data, 'error.message', '');
      alert(error_message);
      self.props.history.go(-1);
    }).then(() => {
      const workflow_process_id = this.state.workflow_process.id;
      if (!_.isEmpty(workflow_process_id)) {
        WorkflowProcessStore.request({id: workflow_process_id, action: 'pdf'}).then((resp)=>{
          let pdf_file = _.get(resp.data, 'data', {});
          this.setState({pdf_file: pdf_file, loading: false});
        }).then(()=>{
          this.setState({loading: false});
        })
      }
    });
  }

  attachmentToggle(){
    let show = true;
    if (this.state.show_attachment) {
      show = false;
    }
    this.setState({show_attachment: show, show_reference_document: false});
  }

  referenceDocumentToggle(){
    let show = true;
    if (this.state.show_reference_document) {
      show = false;
    }
    this.setState({show_reference_document: show, show_attachment: false});
  }

  getCommentSize(){
    return _.size(this.state.comments)
  }

  withoutOriginalAttachment(){
    if (_.isEmpty(this.state.attachments)) { return [] };

    const without_original_attachments = _.filter(this.state.attachments, function(a) {
      return a.attributes.is_original == false
    });
    return without_original_attachments
  }

  getAttachmentSize(){
    const without_original_attachments = this.withoutOriginalAttachment();
    return _.size(without_original_attachments);
  }

  getReferenceDocumentSize(){
    return _.size(this.state.reference_documents)
  }

  redirectToEditDocumentPage(){
    const document = this.state.document;

    this.props.history.push(`/templates/documents/${document.attributes.parent_id}/edit/${document.attributes.parent_document_template.id}`);
  }

  redirectToCreateFrontPage(){
    const document = this.state.document;
    this.props.history.push(`/frontpage/${document.attributes.child_id}/new`);
  }

  redirectToEditFrontPage(){
    const document = this.state.document;
    this.props.history.push(`/frontpage/${document.attributes.child_id}/edit`);
  }

  redirectBack(){
    this.props.history.go(-1);
  }

  openReviewerModal(){
    this.setState({
      modal_open: true,
      modal_form: "select_reviewer",
      loading: true
    }, this.fetchInternalUsers());
  }

  openCommentModal(){
    this.setState({
      modal_open: true,
      modal_form: "add_comment",
    });
  }

  openCommentListModal(){
    this.setState({
      modal_open: true,
      modal_form: "comment_list",
      modal_title: "ความคิดเห็น",
      loading: true
    }, this.fetchCommentWorkflowProcessHistory());
  }

  openConfirmModal(){
    this.setState({
      modal_open: true,
      modal_form: "confirm",
      confirmed: false
    });
  }

  openReceiveNumberModal(){
    this.setState({
      modal_open: true,
      modal_form: "receive_number",
    });
  }

  openIssueNumberModal(){
    this.setState({
      modal_open: true,
      modal_form: "issue_number",
    });
  }

  openFrontPageIssueNumberModal(){
    this.setState({
      modal_open: true,
      modal_form: "front_page_issue_number",
    });
  }

  openNoteModal(){
    this.setState({
      modal_open: true,
      modal_form: "note",
      loading: true
    }, this.fetchInternalUsers());
  }

  openEditNoteModal(){
    this.setState({
      modal_open: true,
      modal_form: "edit_note",
    });
  }

  openOrderModal(){
    this.setState({
      modal_open: true,
      modal_form: "order",
    });
  }

  openForwardModal(){
    this.setState({
      modal_open: true,
      modal_form: "forward",
      loading: true
    }, this.fetchInternalUsers());
  }

  openForwardSecretaryModal(){
    this.setState({
      modal_open: true,
      modal_form: "forward_secretary",
    });
  }

  handleActionClick(action_name){
    this.preventMultiClicks();

    const state_name = this.state.workflow_process.attributes.current_workflow_state.attributes.state_name;
  
    if(action_name === "กลับ"){
      this.redirectBack();
      return;
    }

    if(state_name === "ส่งต่อเกษียน"){
      this.setState({action_name: action_name}, () => {
        this.handleSubmitAction();
      });
      
      return;
    }

    this.setState({action_name: action_name}, () => {
      switch(action_name) {
        case "คัดลอก":
          this.handleCloneDocument();
          break;
        case "แก้ไข":
          this.redirectToEditDocumentPage();
          break;
        case "แก้ไขเอกสารหลัก":
          this.redirectToEditDocumentPage();
          break;
        case "ร่างใบปะหน้า":
          this.redirectToCreateFrontPage();
          break;
        case "แก้ไขใบปะหน้า":
          this.redirectToEditFrontPage();
          break;
        case "ส่งตรวจทาน":
          this.setState({modal_title: "ส่งตรวจทาน"}, () => {
            this.openReviewerModal();
          })
          break;
        case "ส่งกลับแก้ไข":
          this.setState({modal_title: "ส่งกลับแก้ไข"}, () => {
            this.openCommentModal();
          })
          break;
        case "ยกเลิกเอกสาร":
          this.setState({modal_title: "ยกเลิกเอกสาร"}, () => {
            this.openCommentModal();
          })
          break;
        case "ส่งกลับผู้ร่าง":
          this.setState({modal_title: "ส่งกลับผู้ร่าง"}, () => {
            this.openCommentModal();
          })
          break;
        case "ผ่าน (ส่งต่อผู้ลงนาม)":
          this.handleSubmitAction();
          break;
        case "ลงนาม":
          this.handleSubmitAction();
          break;
        case "ออกเลข":
          this.handleSubmitAction();
          break;
        case "ออกเลข (ใบปะหน้า)":
          this.handleSubmitAction();
          break;
        case "ผ่าน (ใบปะหน้า)":
          this.setState({modal_title: "ส่งผ่านใบปะหน้า"}, () => {
            this.openEditNoteModal();
          })
          break;
        case "ส่งผ่าน":
          this.setState({modal_title: "ส่งผ่าน"}, () => {
            this.openEditNoteModal();
          })
          break;
        case "ส่งต่อสารบรรณ":
          this.handleSubmitAction();
          break;
        case "ส่งกลับสารบรรณ":
          this.handleSubmitAction();
          break;
        case "ผ่าน":
          this.handleSubmitAction();
          break;
        case "ไม่ผ่าน":
          this.setState({modal_title: "ส่งกลับผู้ร่าง"}, () => {
            this.openCommentModal();
          })
          break;
        case "บันทึกรับ":
          this.setState({modal_title: "ยืนยันการบันทึกรับเพื่อดำเนินการต่อ"}, () => {
            this.openConfirmModal();
          })
          break;
        case "แทรกเลข":
          this.setState({modal_title: "แทรกเลข"}, () => {
            if(state_name === "รอออกเลข"){
              this.openIssueNumberModal();
            } else {
              this.openReceiveNumberModal();
            }
          })
          break;
        case "แทรกเลข (ใบปะหน้า)":
          this.setState({modal_title: "แทรกเลข (ใบปะหน้า)"}, () => {
            if(state_name === "รอออกเลข (ใบปะหน้า)"){
              this.openFrontPageIssueNumberModal();
            } else {
              this.openReceiveNumberModal();
            }
          })
          break;
        case "ส่งคืน":
          this.setState({modal_title: "ส่งคืน"}, () => {
            this.openCommentModal();
          })
          break;
        case "ส่งต่อ":
          this.setState({modal_title: "ส่งต่อ"}, () => {
            this.openForwardModal();
          })
          break;
        case "ส่งต่อ (สั่งการเพิ่มเติม)":
          this.setState({modal_title: "ส่งต่อ (สั่งการเพิ่มเติม)"}, () => {
            this.openForwardModal();
          })
          break;
        case "นำเสนอเกษียนหนังสือ":
          this.setState({modal_title: "นำเสนอเกษียนหนังสือ"}, () => {
            this.openNoteModal();
          })
          break;
        case "นำเสนอเกษียน":
          this.setState({modal_title: "นำเสนอเกษียนหนังสือ"}, () => {
            this.openNoteModal();
          })
          break;
        case "ส่งต่อเกษียน":
          this.handleSubmitAction();
          break;
        case "ลงนามกำกับการเกษียน":
          this.handleSubmitAction();
          break;
        case "ส่งกลับหน่วยงาน":
          this.setState({modal_title: "ส่งกลับหน่วยงาน"}, () => {
            this.openCommentModal();
          })
          break;
        case "แก้ไขข้อความสรุป":
          this.setState({modal_title: "แก้ไขข้อความสรุป"}, () => {
            this.openEditNoteModal();
          })
          break;
        case "สั่งการ":
          this.setState({modal_title: "สั่งการ"}, () => {
            this.openOrderModal();
          })
          break;
        case "นำเสนอลงนาม":
          this.setState({modal_title: "นำเสนอลงนาม"}, () => {
            this.openEditNoteModal();
          })
          break;
        case "ส่งต่อเลขา":
          this.setState({modal_title: "ส่งต่อเอกสารไปยัง"}, () => {
            this.openForwardSecretaryModal();
          })
          break;
        case "ส่งกลับเจ้าของเรื่อง":
          this.setState({modal_title: "ส่งกลับเจ้าของเรื่อง"}, () => {
            this.openCommentModal();
          })
          break;
        case "จบการทำงาน":
          this.setState({modal_title: "จบการทำงาน"}, () => {
            this.openCommentModal();
          })
          break;
        case "จัดเก็บเอกสาร":
          this.handleArchiveDocument();
          break;
        case "โหลดเอกสารอีกครั้ง":
          this.handleReloadDocument();
          break;
        case "รับทราบปิดงาน":
          this.setState({modal_title: "รับทราบปิดงาน"}, () => {
            this.openCommentModal();
          })
          break;
        case "ดำเนินการต่อ":
          this.handleReloadWithoutPreview();
          break;
        default:
          alert(action_name);
          break;
      }
    });
  }

  handleSubmitAction(positions_user_id, comment){
    this.preventMultiClicks();
    this.preventMultiConfirms();

    const workflow_process_id = this.state.workflow_process.id;

    WorkflowProcessStore.request({
      id: workflow_process_id,
      method: 'put',
      data: {
        action_name: this.state.action_name,
        positions_user_id: positions_user_id,
        comment: comment
      },
    }).then(()=>{
      this.props.history.push("/documents/mydoc");
    }, function(error){
      let error_message = _.get(error.response.data, 'error.message', '');
      alert(error_message);
    });
  }

  handleArchiveDocument(positions_user_id){
    const workflow_process_id = this.state.workflow_process.id;

    WorkflowProcessStore.request({
      id: workflow_process_id,
      method: 'put',
      action: 'archive'
    }).then(()=>{
      this.props.history.push("/documents/mydoc");
    }, function(error){
      let error_message = _.get(error.response.data, 'error.message', '');
      alert(error_message);
    });
  }

  handleReloadDocument(){
    const workflow_process_id = this.state.workflow_process.id;

    WorkflowProcessStore.request({
      id: workflow_process_id,
      method: 'put',
      action: 'reload'
    }).then(()=>{
      window.location.reload();
    }, function(error){
      let error_message = _.get(error.response.data, 'error.message', '');
      alert(error_message);
    });
  }

  handleSaveNoteMessage(note_data){
    this.disabledClick();
    
    const workflow_process_id = this.state.workflow_process.id;

    WorkflowProcessStore.request({
      id: workflow_process_id,
      method: 'put',
      data: {
        action_name: this.state.action_name,
        note_data: {...note_data},
      },
    }).then(()=>{
      this.props.history.push("/documents/mydoc");
    }, function(error){
      let error_message = _.get(error.response.data, 'error.message', '');
      alert(error_message);
    });
  }

  handleUpdateNoteMessage(note_text){
    this.disabledClick();
    
    const workflow_process_id = this.state.workflow_process.id;

    WorkflowProcessStore.request({
      id: workflow_process_id,
      method: 'put',
      data: {
        action_name: this.state.action_name,
        note_data: { 
          note_text: note_text
        },
      },
    }).then(()=>{
      this.props.history.push("/documents/mydoc");
    }, function(error){
      let error_message = _.get(error.response.data, 'error.message', '');
      alert(error_message);
    });
  }

  handleOrder(note_text, positions_user_ids){
    this.disabledClick();
    
    const workflow_process_id = this.state.workflow_process.id;

    WorkflowProcessStore.request({
      id: workflow_process_id,
      method: 'put',
      data: {
        action_name: this.state.action_name,
        positions_user_ids: positions_user_ids,
        note_data: {
          note_text: note_text
        }
      },
    }).then(()=>{
      this.props.history.push("/documents/mydoc");
    }, function(error){
      let error_message = _.get(error.response.data, 'error.message', '');
      alert(error_message);
    });
  }

  handleForward(targets, note_text){
    this.disabledClick();
    
    const workflow_process_id = this.state.workflow_process.id;

    WorkflowProcessStore.request({
      id: workflow_process_id,
      method: 'put',
      data: {
        action_name: this.state.action_name,
        targets: targets,
        note_data: {
          note_text: note_text
        }
      },
    }).then(()=>{
      this.props.history.push("/documents/mydoc");
    }, function(error){
      let error_message = _.get(error.response.data, 'error.message', '');
      alert(error_message);
    });
  }

  handleForwardSecretary(note_text, department_group_id){
    this.disabledClick();
    
    const workflow_process_id = this.state.workflow_process.id;

    WorkflowProcessStore.request({
      id: workflow_process_id,
      method: 'put',
      data: {
        action_name: this.state.action_name,
        note_data: {
          department_group_id: department_group_id,
          note_text: note_text
        }
      },
    }).then(()=>{
      this.props.history.push("/documents/mydoc");
    }, function(error){
      let error_message = _.get(error.response.data, 'error.message', '');
      alert(error_message);
    });
  }

  handleSubmitIssueNumber(issue_number_id){
    this.preventMultiClicks();
    
    const workflow_process_id = this.state.workflow_process.id;

    WorkflowProcessStore.request({
      id: workflow_process_id,
      method: 'put',
      data: {
        action_name: this.state.action_name,
        issue_number_id: issue_number_id
      },
    }).then(()=>{
      this.props.history.push("/documents/mydoc");
    }, function(error){
      let error_message = _.get(error.response.data, 'error.message', '');
      alert(error_message);
    });
  }

  handleSubmitReceiveNumber(receive_number_id){
    this.preventMultiClicks();
    
    const workflow_process_id = this.state.workflow_process.id;

    WorkflowProcessStore.request({
      id: workflow_process_id,
      method: 'put',
      data: {
        action_name: this.state.action_name,
        receive_number_id: receive_number_id
      },
    }).then(()=>{
      this.props.history.push("/documents/mydoc");
    }, function(error){
      let error_message = _.get(error.response.data, 'error.message', '');
      alert(error_message);
    });
  }

  handleCloneDocument(){
    const document_id = this.state.document.id;
    const template_id = this.state.document.attributes.document_template.id;

    this.props.history.push("/templates/" + template_id + "/new?clone_document_id=" + document_id);
  }

  handleReloadWithoutPreview(){
    window.location = window.location.pathname;
  }

  onCloseModal(){
    this.setState({ 
      modal_open: false,
      modal_title: "",
      modal_form: "",
      action_name: "",
    });
  }

  fetchInternalUsers(){
    let url = 'documents/internal_users';

    DocumentStore.request({url: url}).then((resp)=>{
      const internal_users = _.get(resp.data, 'internal_users', []);
      const all_users = _.get(resp.data, 'all_users', []);
      const informee_positions_users = _.get(resp.data, 'informee_positions_users', []);
      const department_groups = _.get(resp.data, 'department_groups', []);
      const secretary_groups = _.get(resp.data, 'secretary_groups', []);
      
      this.setState({
        internal_users: internal_users,
        all_users: all_users,
        informee_positions_users: informee_positions_users,
        department_groups: department_groups,
        secretary_groups: secretary_groups
      })
    }).then(()=>{
      this.setState({loading: false});
    })
  }

  fetchCommentWorkflowProcessHistory(){
    const workflow_process_id = this.state.workflow_process.id;

    WorkflowProcessStore.request({id: workflow_process_id, action: 'workflow_process_histories'}).then((resp)=>{
      const workflow_process_histories = _.get(resp.data, 'workflow_process_histories', []);
      const comment_wph_histories = _.reject(workflow_process_histories, function(wph) { 
                                  return _.isEmpty(wph.attributes.comment) && _.isEmpty(wph.attributes.note_text); 
                                })

      this.setState({
        comment_wph_histories: comment_wph_histories
      })
    }).then(()=>{
      this.setState({loading: false});
    })
  }

  render(){
    let state_name = '';
    if (!_.isEmpty(this.state.workflow_process)){
      const workflow_process = this.state.workflow_process;
      state_name = _.get(workflow_process, "attributes.current_workflow_state.attributes.state_name");
    }
    
    const assignees = _.get(this.state.workflow_process, "attributes.positions_users");
    const assignee_position_names = _.map(assignees, (assignee) => {
                                      return assignee.attributes.position_name;
                                    }).join(", ")

    const params = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });

    return (
      <div>
        {this.state.loading && <AfterSaveLoading />}
        
        <TopHeader />

        <div>
          <div className='card mx-2 px-2 py-1 text-white' style={{backgroundColor: 'rgb(49, 90, 125)'}}>
            <h4 className='mb-0'>ตัวอย่างเอกสาร</h4>
            <div className='pl-3'>
              เรียน {assignee_position_names}
            </div>
            <div className='pl-3'>
              {state_name}
            </div>
          </div>

          <div className='m-2'>
            <div>
              <button type='button' className='btn btn-sm btn-secondary mr-2 mb-2' onClick={this.openCommentListModal}>
                <i className="fa fa-weixin mr-2" aria-hidden="true"></i>
                ความคิดเห็น ({this.getCommentSize()})
              </button>
              <button type='button' className='btn btn-sm btn-secondary mr-2 mb-2' onClick={this.attachmentToggle}>
                <i className="fa fa-file mr-2" aria-hidden="true"></i>
                เอกสารแนบ ({this.getAttachmentSize()})
              </button>
              <button type='button' className='btn btn-sm btn-secondary mr-2 mb-2' onClick={this.referenceDocumentToggle}>
                <i className="fa fa-tasks mr-2" aria-hidden="true"></i>
                เอกสารอ้างอิง ({this.getReferenceDocumentSize()})
              </button>
            </div>

            {!_.isEmpty(this.state.workflow_process) && (
              <DocumentActions  document={this.state.document} 
                                workflow_process={this.state.workflow_process} 
                                isSecretary={this.state.isSecretary}
                                onActionClick={this.handleActionClick}
                                clicked={this.state.clicked}
                                preview={params.preview} />
            )}

            {this.state.show_attachment && (
              <div className='card bg-light p-2 mt-2'>
                <AttachmentList attachments={this.withoutOriginalAttachment()} 
                                pdf_file={this.state.pdf_file} 
                                document={this.state.document} />
              </div>
            )}

            {this.state.show_reference_document && (
              <div className='card bg-light p-2 mt-2'>
                <ReferenceDocumentList  reference_documents={this.state.reference_documents} />
              </div>
            )}

            {!_.isEmpty(this.state.workflow_process) && (
              <DocumentExample 
                document={this.state.document} 
                workflow_process={this.state.workflow_process}
                pdf_file={this.state.pdf_file} />
            )}
          </div>
        </div>

        <SimpleModal 
          isOpen={this.state.modal_open}
          title={this.state.modal_title}
          size={'modal-lg'}
          showSubmitButton={false}
          onClose={this.onCloseModal}>
            {this.state.modal_form === "select_reviewer" && (
              <SelectReviewer internal_users={this.state.internal_users} 
                              all_users={this.state.all_users}
                              acting_positions_user_ids={this.state.acting_positions_user_ids}
                              actings={this.state.actings}
                              onSubmitAction={this.handleSubmitAction}
                              onCloseModal={this.onCloseModal} />
            )}
            {this.state.modal_form === "add_comment" && (
              <AddComment onSubmitAction={this.handleSubmitAction}
                          clicked={this.state.clicked}
                          onCloseModal={this.onCloseModal} />
            )}
            {this.state.modal_form === "confirm" && (
              <Confirm  onSubmitAction={this.handleSubmitAction}
                        confirmed={this.state.confirmed}
                        onCloseModal={this.onCloseModal} />
            )}
            {this.state.modal_form === "issue_number" && (
              <IssueNumber  workflow_process={this.state.workflow_process}
                            onSubmitAction={this.handleSubmitIssueNumber}
                            clicked={this.state.clicked}
                            onCloseModal={this.onCloseModal}
                            type_name={this.state.workflow_process.attributes.type_name} />
            )}
            {this.state.modal_form === "front_page_issue_number" && (
              <IssueNumber  workflow_process={this.state.workflow_process}
                            is_front_page={true}
                            onSubmitAction={this.handleSubmitIssueNumber}
                            clicked={this.state.clicked}
                            onCloseModal={this.onCloseModal}
                            type_name={this.state.workflow_process.attributes.type_name} />
            )}
            {this.state.modal_form === "receive_number" && (
              <ReceiveNumber  onSubmitAction={this.handleSubmitReceiveNumber}
                              clicked={this.state.clicked}
                              onCloseModal={this.onCloseModal}
                              type_name={this.state.workflow_process.attributes.type_name} />
            )}
            {this.state.modal_form === "note" && (
              <Note internal_users={this.state.internal_users} 
                    informee_positions_users={this.state.informee_positions_users}
                    department_groups={this.state.department_groups}
                    acting_positions_user_ids={this.state.acting_positions_user_ids}
                    actings={this.state.actings}
                    onSubmitAction={this.handleSaveNoteMessage}
                    clicked={this.state.clicked}
                    onCloseModal={this.onCloseModal} />
            )}
            {this.state.modal_form === "edit_note" && (
              <EditNote onSubmitAction={this.handleUpdateNoteMessage}
                        clicked={this.state.clicked}
                        onCloseModal={this.onCloseModal} />
            )}
            {this.state.modal_form === "order" && (
              <Order  internal_users={this.state.internal_users}
                      workflow_process={this.state.workflow_process}
                      onSubmitAction={this.handleOrder}
                      clicked={this.state.clicked}
                      onCloseModal={this.onCloseModal} />
            )}
            {this.state.modal_form === "forward" && (
              <Forward  internal_users={this.state.internal_users}
                        department_groups={this.state.department_groups}
                        workflow_process={this.state.workflow_process}
                        acting_positions_user_ids={this.state.acting_positions_user_ids}
                        actings={this.state.actings}
                        onSubmitAction={this.handleForward}
                        clicked={this.state.clicked}
                        onCloseModal={this.onCloseModal} />
            )}
            {this.state.modal_form === "forward_secretary" && (
              <ForwardSecretary department_groups={this.state.secretary_groups}
                                workflow_process={this.state.workflow_process}
                                onSubmitAction={this.handleForwardSecretary}
                                clicked={this.state.clicked}
                                onCloseModal={this.onCloseModal} />
            )}
            {this.state.modal_form === "comment_list" && (
              <CommentList  comment_wph_histories={this.state.comment_wph_histories}
                            workflow_states={this.state.workflow_states}
                            workflow_state_actions={this.state.workflow_state_actions}
                            workflow_process_id={this.props.workflow_process_id}
                            comments={this.state.comments}
                            comment_files={this.state.comment_files}
                            onReloadWorkflowProcess={this.reloadWorkflowProcess}
                            onCloseModal={this.onCloseModal} />
            )}
        </SimpleModal>
      </div>
    )
  }
}

export default withRouter(ShowDocument);



// WEBPACK FOOTER //
// ./src/components/documents/ShowDocument.js